import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui/button";
import { ClockIcon } from "~/components/ui/icons/clock";

export type OnboardingStepWelcomeProps = {
  goToNextStep: () => void;
};

export const OnboardingStepWelcome: React.FC<OnboardingStepWelcomeProps> = ({
  goToNextStep,
}: OnboardingStepWelcomeProps) => {
  const { t } = useTranslation();

  return (
    <section className="w-full">
      <div className="mt-8 flex flex-col gap-10 sm:mt-20">
        <h2 className="text-2xl font-bold text-gray-900 sm:text-3.5xl">
          {t("onboarding.welcome.title")}
        </h2>

        <div className="space-y-4">
          <div className="flex flex-initial gap-4 self-start rounded-lg border border-gray-300 p-6 pr-8 text-gray-900">
            <ClockIcon className="size-6" />
            <div className="flex flex-col gap-2">
              <p className="text-sm font-semibold">
                {t("onboarding.welcome.time_needed")}
              </p>
              <p className="text-sm leading-5.5">
                {t("onboarding.welcome.about_x_minutes", {
                  minutes: "8",
                })}
              </p>
            </div>
          </div>
        </div>

        <Button
          size="lg"
          type="submit"
          onClick={goToNextStep}
          className="self-start"
        >
          {t("onboarding.welcome.start_configuration")}
        </Button>
      </div>
    </section>
  );
};
